import React from 'react';
import { CMS } from './SearchModels';
import { ItemContent } from '../../StyledComponents/Grid';
import ContentCard from '../../StyledComponents/ContentCard';
import { imageWithWidth } from '../../utils/image';

interface ContentItemProps {
  data: CMS;
}

const ContentItem = ({ data }: ContentItemProps) => {
  return (
    <ItemContent>
      <ContentCard
        image={
          data.content?.open_graph?.image
            ? imageWithWidth(data.content.open_graph.image, 112, 112)
            : undefined
        }
        image2x={
          data.content?.open_graph?.image
            ? imageWithWidth(data.content.open_graph.image, 224, 224)
            : undefined
        }
        heading={data.content?.title || ''}
        preamble={
          data?._highlight?.all_text_content ||
          data?._highlight?.['all_text_content.stem'] ||
          undefined
        }
        link={data.link ? `${window.location.origin}${data.link}` : undefined}
        breadcrumb={data.breadcrumb}
      />
    </ItemContent>
  );
};

export default ContentItem;
